export enum PlanStatus {
  InTrial = 'InTrial',
  Cancelled = 'Cancelled',
  NonRenewing = 'NonRenewing',
  Active = 'Active'
}

export enum PlanTier {
  Free = 'free',
  Team = 'team',
  Business = 'business',
  Enterprise = 'enterprise',
  Connect = 'connect'
}

export enum PlanPrefix {
  Awork = 'awork',
  Q = 'q'
}

export enum PlanPeriod {
  Monthly = 1,
  Yearly = 12,
  Sixteen = 16,
  BiYearly = 24
}

export enum Plan {
  // ------------- Pricing plans: 2025 --------------- //
  Basic2025 = 'basic-2025',
  Standard2025 = 'standard-2025',
  Professional2025 = 'professional-2025',
  Enterprise2025 = 'enterprise-2025',
  EnterprisePlus2025 = 'enterpriseplus-2025',
  ConnectEUR2025 = 'connect-eur-2025',
  ConnectGBP2025 = 'connect-gbp-2025',
  ConnectUSD2025 = 'connect-usd-2025',
  ConnectCHF2025 = 'connect-chf-2025',
  // ------------- Pricing plans: 2023 --------------- //
  Team = 'team-2023',
  Business = 'business-2023',
  AworkBusiness = 'awork-business',
  Enterprise = 'enterprise-2023',
  Connect = 'connect-2024',
  // ------------- Pricing plans: Legacy --------------- //
  Internal = 'internalfree',
  DeveloperFree = 'developer-free',
  Free = 'free',
  NewFree = 'free-new',
  LegacyStandard = 'standard',
  LegacyEnterprise = 'enterprise',
  LegacyBuhl = 'buhl'
}

export enum PlanId {
  ConnectEUR2025Monthly = `${Plan.ConnectEUR2025}-${PlanPeriod.Monthly}`,
  ConnectGBP2025Monthly = `${Plan.ConnectGBP2025}-${PlanPeriod.Monthly}`,
  ConnectUSD2025Monthly = `${Plan.ConnectUSD2025}-${PlanPeriod.Monthly}`,
  ConnectCHFGBP2025Monthly = `${Plan.ConnectCHF2025}-${PlanPeriod.Monthly}`,
  // Current plans
  TeamMonthly = `${Plan.Team}-${PlanPeriod.Monthly}`,
  TeamYearly = `${Plan.Team}-${PlanPeriod.Yearly}`,
  TeamBiYearly = `${Plan.Team}-${PlanPeriod.BiYearly}`,
  BusinessMonthly = `${Plan.Business}-${PlanPeriod.Monthly}`,
  BusinessYearly = `${Plan.Business}-${PlanPeriod.Yearly}`,
  BusinessBiYearly = `${Plan.Business}-${PlanPeriod.BiYearly}`,
  EnterpriseYearly = `${Plan.Enterprise}-${PlanPeriod.Yearly}`,
  EnterpriseBiYearly = `${Plan.Enterprise}-${PlanPeriod.BiYearly}`,
  Connect = `${Plan.Connect}-${PlanPeriod.Monthly}`,
  // Legacy plans
  AworkStandardMonthly = `${PlanPrefix.Awork}-${Plan.LegacyStandard}-${PlanPeriod.Monthly}`,
  AworkStandardYearly = `${PlanPrefix.Awork}-${Plan.LegacyStandard}-${PlanPeriod.Yearly}`,
  AworkStandardBiYearly = `${PlanPrefix.Awork}-${Plan.LegacyStandard}-${PlanPeriod.BiYearly}`,
  AworkEnterpriseMonthly = `${PlanPrefix.Awork}-${Plan.LegacyEnterprise}-${PlanPeriod.Monthly}`,
  AworkEnterpriseYearly = `${PlanPrefix.Awork}-${Plan.LegacyEnterprise}-${PlanPeriod.Yearly}`,
  AworkEnterpriseBiYearly = `${PlanPrefix.Awork}-${Plan.LegacyEnterprise}-${PlanPeriod.BiYearly}`,
  AworkEnterpriseVolumeVDMBiYearly = `${PlanPrefix.Awork}-${Plan.LegacyEnterprise}-volume-vdm-${PlanPeriod.BiYearly}`,
  QBuhlMonthly = `${PlanPrefix.Q}-${Plan.LegacyBuhl}-${PlanPeriod.Monthly}`,
  QBuhlYearly = `${PlanPrefix.Q}-${Plan.LegacyBuhl}-${PlanPeriod.Yearly}`,
  QStandardMonthly = `${PlanPrefix.Q}-${Plan.LegacyStandard}-${PlanPeriod.Monthly}`,
  QStandardSpecialSixteen = `${PlanPrefix.Q}-${Plan.LegacyStandard}-${PlanPeriod.Monthly}-16`,
  QStandardYearly = `${PlanPrefix.Q}-${Plan.LegacyStandard}-${PlanPeriod.Yearly}`,
  QStandardBiYearly = `${PlanPrefix.Q}-${Plan.LegacyStandard}-${PlanPeriod.BiYearly}`,
  QEnterpriseMonthly = `${PlanPrefix.Q}-${Plan.LegacyEnterprise}-${PlanPeriod.Monthly}`,
  QEnterpriseYearly = `${PlanPrefix.Q}-${Plan.LegacyEnterprise}-${PlanPeriod.Yearly}`,
  QEnterpriseBiYearly = `${PlanPrefix.Q}-${Plan.LegacyEnterprise}-${PlanPeriod.BiYearly}`,
  // Free plans
  QLegacyFreeMonthly = `${PlanPrefix.Q}-${Plan.Free}-${PlanPeriod.Monthly}`,
  QFreeMonthly = `${PlanPrefix.Q}-${Plan.NewFree}-${PlanPeriod.Monthly}`,
  QInternalFreeMonthly = `${PlanPrefix.Q}-${Plan.Internal}-${PlanPeriod.Monthly}`,
  DeveloperFreeMonthly = `${Plan.DeveloperFree}-${PlanPeriod.Monthly}`
}

export enum PlanVersion {
  Legacy = 'legacy',
  Current = 'current'
}
